import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Film, LogOut, LayoutDashboard, Shield } from "lucide-react";

export const Header = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="fixed top-0 inset-x-0 z-50 glass" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5 group" data-testid="brand-link">
          <Film className="w-6 h-6 text-[#D4AF37] group-hover:rotate-6 transition-transform" />
          <span className="font-display text-2xl tracking-wide text-white">PROPMOTION</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm text-slate-300">
          <Link to="/order/most-popular" className="hover:text-[#D4AF37] transition-colors" data-testid="nav-listing">Listing Films</Link>
          <Link to="/order/vision-standard" className="hover:text-[#D4AF37] transition-colors" data-testid="nav-vision">Vision Films</Link>
          <Link to="/custom" className="hover:text-[#D4AF37] transition-colors" data-testid="nav-custom">Custom Vision</Link>
          <Link to="/pricing" className="hover:text-[#D4AF37] transition-colors" data-testid="nav-pricing">Plans</Link>
        </nav>

        <div className="flex items-center gap-3">
          {user ? (
            <>
              {user.role === "admin" && (
                <Button variant="ghost" size="sm" onClick={() => navigate("/admin")}
                  className="text-[#D4AF37] hover:bg-[#D4AF37]/10" data-testid="nav-admin">
                  <Shield className="w-4 h-4 mr-1.5" /> Admin
                </Button>
              )}
              <Button variant="ghost" size="sm" onClick={() => navigate("/dashboard")}
                className="text-slate-200 hover:bg-white/5" data-testid="nav-dashboard">
                <LayoutDashboard className="w-4 h-4 mr-1.5" /> Dashboard
              </Button>
              <Button variant="ghost" size="sm" onClick={async () => { await logout(); navigate("/"); }}
                className="text-slate-400 hover:bg-white/5" data-testid="logout-button">
                <LogOut className="w-4 h-4" />
              </Button>
            </>
          ) : (
            <>
              <Button variant="ghost" size="sm" onClick={() => navigate("/login")}
                className="text-slate-200 hover:bg-white/5" data-testid="nav-login">Sign In</Button>
              <Button size="sm" onClick={() => navigate("/order/most-popular")}
                className="bg-[#D4AF37] text-black hover:bg-[#E2C044] rounded-full px-5" data-testid="nav-cta">
                Create a Film
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
};
